import i18n from "i18next";
import i18nBackend from "i18next-http-backend";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(detector)
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    // fallbackLng: false,
    backend: {
      loadPath: `/i18n/{{lng}}.json`,
      requestOptions: {
        cache: "no-store",
      },
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
